import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';
import { PhaserButton, PhaserButtonConfig } from '../../shared/Button';
import { Color } from 'src/games/shared/ColorValue';

export class GameOverScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;

    constructor() {
        super({
            key: "GameOverScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in DrawBloodScene
        this.load.tilemapTiledJSON("game_over_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_game_over_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'game_over_scene_map' });
    }

    generateScene() {
        let background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);

        this.addObjects();
    }

    addObjects(): void {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "alien") {
                var alien = this.add.image(ob.x, ob.y, "assets", "sleb_normal");
                alien.setOrigin(0);
                alien.setDisplaySize(ob.width, ob.height);
                alien.setDepth(3);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Roboto Mono, Arial', fontSize: 20, color: '#F8E71C', padding: 20, backgroundColor: "#000000" };
                var translateString = "Diagnosis.Phaser.GameOverScene.";
                var text1 = TranslateApi.translate(translateString + "text1");
                var text2 = TranslateApi.translate(translateString + "text2");
                var diseaseName = TranslateApi.translate(GameState.current.correctDiagnosis.diseaseName);
                var translatedText = text1 + diseaseName + text2;
                var box = this.add.text(ob.x, ob.y, translatedText, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth / 2 - box.displayWidth / 2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });

        var config: PhaserButtonConfig = {
            backgroundColor: Color.KUDER_PRIMARY_BUTTON,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        var button = new PhaserButton(this, 0, 0, 200, 200, TranslateApi.translate("common.done"), config);
        button.setPosition(this.gameWidth - button.width - 50, this.gameHeight - button.height - 50);
        button.on("buttonClicked", () => {
            // Game Over
            (this.sys.game as any).onComplete();
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/GameOverScene.ts